<div *ngIf="check" id="checkRecord" #checkRecord>
	<p-card styleClass="m-2" *ngIf="check">
		<div class="d-flex">
			<div (click)="showCheckKey = !showCheckKey" class="display-6">Check {{ check.checkNumber }}</div>
			<div *ngIf="showCheckKey" class="ms-auto my-auto" (click)="app.copyMessage(check.checkKey)">Check Key: {{ check.checkKey }}</div>
			<div class="ms-auto">
				<fa-icon
					[icon]="['far', 'file-pdf']"
					size="2x"
					(click)="app.generatePdfForDownload('checkRecord', 'Check ' + check.checkNumber)"
					class="ms-2 my-auto"
				></fa-icon>
			</div>
		</div>
		<p-divider></p-divider>
		<div class="p-grid">
			<div class="p-col">Table: {{ check.table }}</div>
		</div>
		<div class="p-grid">
			<div class="p-col">Opened: {{ moment(check.timeOpened).format('l') }}</div>
			<div class="p-col" style="text-align: right">
				Status:
				<span *ngIf="check.open"> open </span>
				<span *ngIf="!check.open"> closed </span>
			</div>
		</div>
	</p-card>
	<p-card *ngIf="check?.firstName || check?.customerKey" styleClass="m-2">
		<ng-template pTemplate="header">
			<div class="d-flex m-2">
				<fa-icon [icon]="['far', 'user-crown']" size="lg" class="me-2"></fa-icon>
				<h4>
					{{ app.references.toTitleCase(customer?.firstName || check.firstName) }}
					{{ app.references.toTitleCase(customer?.lastName || check.lastName) }}
				</h4>
			</div>
		</ng-template>
		<div class="p-grid">
			<div class="p-col">Email:</div>
			<div class="p-col">
				{{ customer?.email || check.email }}
			</div>
		</div>
		<div class="p-grid">
			<div class="p-col">Phone:</div>
			<div class="p-col">
				<span *ngIf="check.phone">
					{{ app.references.phoneNumberToDisplayFormat(customer?.phone[0] || check.phone) }}
				</span>
			</div>
		</div>
		<div *ngIf="customer">
			<div class="p-grid">
				<div class="p-col">First Visit</div>
				<div class="p-col">
					{{ moment(customer.firstVisitDate).format('l LT') }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">Last Visit</div>
				<div class="p-col">
					{{ moment(customer.lastVisitDate).format('l LT') }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">Visits</div>
				<div class="p-col">
					{{ customer.visitCount }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">Total Revenue</div>
				<div class="p-col">
					{{ customer.totalRevenue | currency }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">Avg Spend /visit</div>
				<div class="p-col">
					{{ customer.totalRevenue / customer.visitCount | currency }}
				</div>
			</div>
		</div>

		<div class="p-grid">
			<div class="p-col">
				<span *ngIf="check.loyaltyAccount"> <fa-icon [icon]="['far', 'angel']"></fa-icon>Loyalty ID: {{ check.loyaltyAccount }} </span>
			</div>
		</div>
		<div class="d-flex">
			<a *ngIf="customer" (click)="viewCustomer = true">View Full Customer Profile</a>
		</div>
	</p-card>
	<p-card *ngIf="check.futureOrder" class="m-2">
		<ng-template pTemplate="header">
			<div class="d-flex m-2">
				<fa-icon [icon]="['far', 'user-crown']" size="lg" class="me-2"></fa-icon>
				<h4>future order details</h4>
			</div>
		</ng-template>
		<div class="p-grid">
			<div class="p-col">Order placed</div>
			<div class="p-col">
				{{ moment(check.created).format('l LT') }}
			</div>
		</div>
		<div class="p-grid">
			<div class="p-col">Requested Date</div>
			<div class="p-col">
				{{ moment(check.dueDateTime).format('l LT') }}
			</div>
		</div>
		<div class="p-grid">
			<div class="p-col">
				<span *ngIf="check.pos">Printed at</span>
				<span *ngIf="!check.pos">Will print on</span>
			</div>
			<div class="p-col">
				{{ moment(check.queueDateTime).format('l LT') }}
			</div>
		</div>
	</p-card>
	<p-card *ngIf="check.address" class="m-2">
		<ng-template pTemplate="header">
			<div class="d-flex m-2">
				<fa-icon [icon]="['far', 'user-crown']" size="lg" class="me-2"></fa-icon>
				<h4>delivery details</h4>
			</div>
		</ng-template>
		<div class="p-grid">
			<div class="p-col">Address</div>
			<div class="p-col">
				<div class="d-flex flex-column">
					<div>{{ check.address }}</div>
					<div *ngIf="check.address2">{{ check.address2 }}</div>
					<div>{{ check.city }}, {{ check.state }} {{ check.zip }}</div>
				</div>
			</div>
		</div>
	</p-card>

	<div class="d-flex overflow-scroll">
		<p-button
			pRipple
			*ngFor="let seat of check.seats"
			[styleClass]="seatKey == seat.seatKey ? ' p-button-rounded m-2' : 'p-button-outlined p-button-rounded m-2'"
			(click)="selectSeat(seat.seatKey)"
		>
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="['far', 'utensils']" size="lg" class="ms-1"></fa-icon>
					<div class="mx-2 text-nowrap">
						{{ seat.seatKey }}
					</div>
				</div>
			</ng-template>
		</p-button>
	</div>

	<p-card styleClass="m-2">
		<div class="d-flex">
			<div class="h3">Seat {{ seatKey }}</div>
		</div>
		<p-divider></p-divider>
		<div *ngFor="let item of seatSelected.items">
			<div class="p-grid" *ngIf="!item.void">
				<div class="p-col">
					<span *ngIf="item.priceNumberName">{{ item.priceNumberName }}</span> {{ item.name }}
				</div>
				<div class="p-col" style="text-align: right">
					<span class="me-1" *ngIf="item.quantity > 1">
						<i>{{ item.quantity }} @ {{ item.price | currency }} </i>
					</span>
					<span *ngIf="item.quantity === 1">
						{{ item.price | currency }}
					</span>
					<span *ngIf="item.quantity > 1">
						{{ item.price * item.quantity | currency }}
					</span>
				</div>
			</div>
			<div class="p-grid" *ngIf="item.void">
				<div class="p-col">
					<span class="voidText" *ngIf="item.void">
						<span *ngIf="item.priceNumberName">{{ item.priceNumberName }}</span> {{ item.name }}
					</span>
				</div>
				<div class="p-col">$0</div>
			</div>
			<div *ngFor="let mod of item.modifiers">
				<div class="ms-2 p-grid">
					<div class="p-col">
						{{ mod.name }}
					</div>
					<div class="p-col" style="text-align: right">
						{{ mod.price | currency }}
					</div>
				</div>
			</div>
		</div>
		<hr />

		<div class="p-grid">
			<div class="p-col">Subtotal</div>
			<div class="p-col" style="text-align: right">
				{{ seatSelected.subtotal | currency }}
			</div>
		</div>
		<div class="p-grid">
			<div class="p-col">Taxes</div>
			<div class="p-col" style="text-align: right">
				{{ seatSelected.taxtotal | currency }}
			</div>
		</div>
		<div class="p-grid" *ngIf="seatSelected.discountTotal">
			<div class="p-col">Discounts</div>
			<div class="p-col" style="text-align: right">
				{{ seatSelected.discountTotal | currency }}
			</div>
		</div>
		<div class="p-grid" *ngIf="seatSelected.orderTypeChargeTotal">
			<div class="p-col">Order Type Fees</div>
			<div class="p-col" style="text-align: right">
				{{ seatSelected.orderTypeChargeTotal | currency }}
			</div>
		</div>
		<div class="p-grid" *ngIf="seatSelected.creditCardPassAlongFee">
			<div class="p-col">Credit Card Surcharge</div>
			<div class="p-col" style="text-align: right">
				{{ seatSelected.creditCardPassAlongFee | currency }}
			</div>
		</div>
		<div class="p-grid">
			<div class="p-col">Total</div>
			<div class="p-col" style="text-align: right">
				{{ seatSelected.total | currency }}
			</div>
		</div>
		<div class="p-grid">
			<div class="p-col">
				<strong>Remaining Balance</strong>
			</div>
			<div class="p-col" style="text-align: right">
				<strong>{{ seatSelected.remainingBalance | currency }}</strong>
			</div>
		</div>
		<br />
		<div *ngFor="let payment of seatSelected.payments">
			<ng-template *ngTemplateOutlet="paymentRecord; context: { $implicit: payment }"></ng-template>
		</div>
		<div *ngFor="let payment of seatSelected.transactions">
			<div *ngIf="!payment.focusPayDatacap">
				<ng-template *ngTemplateOutlet="paymentRecord; context: { $implicit: payment }"></ng-template>
			</div>
		</div>
		<div>
			<a [href]="receiptUrl" target="_blank">View MobilePay Receipt</a>
		</div>
	</p-card>

	<p-dialog
		[(visible)]="viewCustomer"
		*ngIf="viewCustomer"
		[breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
		[style]="{ width: '50vw' }"
		appendTo="body"
		[closable]="false"
	>
		<app-customer-detail [customerKey]="check.customerKey" [venueKey]="check.venueKey" (closeEmitter)="viewCustomer = false"></app-customer-detail>
	</p-dialog>

	<ng-template #paymentRecord let-payment>
		<ng-container *ngIf="payment.focusPayDatacap">
			<app-check-payment [payment]="payment"></app-check-payment>
		</ng-container>
		<ng-container *ngIf="!payment.focusPayDatacap">
			<div *ngIf="payment.displayName !== 'FocusPay'">
				<div class="p-grid">
					<div class="p-col">
						{{ payment.displayName || payment.paymentName }}
					</div>
					<div class="p-col"></div>
					<div class="p-col" style="text-align: right">-${{ payment.amount }}</div>
				</div>
				<div class="p-grid" *ngIf="payment.account">
					<div class="p-col">
						<fa-icon
							*ngIf="payment.transId"
							[icon]="['far', 'info-circle']"
							pTooltip="Invoice ID {{ payment.transId }} </br> Token: {{ payment.token }}"
							(click)="showToken = !showToken"
						></fa-icon>
						<span *ngIf="payment.cardType">{{ payment.cardType }}</span> {{ payment.account }}
						<div *ngIf="showToken && payment.token" (click)="app.copyMessage(payment.token)">
							Token: {{ payment.token }}
							<div class="font-smaller">
								<i>click to copy</i>
							</div>
						</div>
					</div>

					<div class="p-col" *ngIf="payment.transId" style="text-align: right">Auth: {{ payment.authCode }}</div>
				</div>
			</div>
		</ng-container>
	</ng-template>
</div>
